import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiTrackedList } from '@/entities/tracking/modules/api/tracking';

export const useTrackedList = (enabled = true) =>
  useFetch({
    api: apiTrackedList,
    keywords: queryKeys.tracking.saved,
    enabled,
    // Robust fallback for the /track page: never serve stale saved-track
    // data and always refetch when the user navigates back, so a parcel's
    // status change shows up even if a realtime push was missed.
    staleTime: 0,
    refetchOnMount: 'always',
  });
